<template>
    <img :src="require(`@/${value}`)" />
</template>
<script>
export default {
    props: {
        value: String
    }
}
</script>
